/**
 * Cristalería sorpresa — promo "Cheves Patrias".
 *
 * Todo el cálculo lo hace Liquid en el servidor (`snippets/promo-cristaleria.liquid`)
 * y el tema re-renderiza la sección en cada cambio del carrito, así que este script
 * NO pinta nada: su único trabajo es dejar constancia en el pedido escribiendo un
 * atributo de carrito cuando el cliente cruza (o deja de cruzar) el umbral.
 *
 * No agrega líneas al carrito ni toca precios.
 *
 * Sin bucles: `/cart/update.js` con `attributes` no devuelve secciones ni publica
 * CART_UPDATE en este tema, de modo que la escritura no vuelve a re-renderizar
 * este elemento. La condición `value === current` corta cualquier reintento.
 *
 * Deliberadamente sin dependencias de `Global`: si el runtime del tema cambia,
 * la barra sigue funcionando (es Liquid puro) y esto sigue funcionando también.
 */
(() => {
  if (customElements.get('promo-cristaleria')) return;

  let inFlight = false;

  const cartUpdateURL = () => {
    const dyn = window.dynamicURLs && window.dynamicURLs.cartUpdate;
    if (dyn) return `${dyn}.js`;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root.replace(/\/$/, '')}/cart/update.js`;
  };

  customElements.define(
    'promo-cristaleria',
    class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('write-attr') || inFlight) return;

        const key = this.dataset.attrKey;
        const value = this.dataset.attrValue || '';
        const current = this.dataset.attrCurrent || '';

        if (!key || value === current) return;

        inFlight = true;
        fetch(cartUpdateURL(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ attributes: { [key]: value } }),
        })
          .then((res) => {
            if (res.ok) this.dataset.attrCurrent = value;
          })
          .catch((err) => {
            console.error('[promo-cristaleria] no se pudo escribir el atributo', err);
          })
          .finally(() => {
            inFlight = false;
          });
      }
    }
  );
})();
